import { render, staticRenderFns } from "./Row1.vue?vue&type=template&id=37c99e8c&scoped=true"
import script from "./Row1.vue?vue&type=script&lang=js"
export * from "./Row1.vue?vue&type=script&lang=js"
import style0 from "./Row1.vue?vue&type=style&index=0&id=37c99e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c99e8c",
  null
  
)

export default component.exports